var App = App || {};

App.SecondaryPromos = (function ($) {
    "use strict";

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    carousel = $this.find(".splide");

                if (carousel.length) {
                    Carousel(carousel);
                }
            });
        }
    }

    function Carousel(carousel) {
        const splide = new Splide(carousel[0], {
            breakpoints: {
                576: {
                    padding: {
                        right: "10%"
                    },
                    perPage: 2
                },
                992: {
                    padding: {
                        right: "7%"
                    },
                    perPage: 3
                }
            },
            gap: "1rem",
            mediaQuery: "min",
            padding: {
                left: "0.75rem",
                right: "18%"
            },
            pagination: false,
            perMove: 1,
            perPage: 1
        });

        // Apply proper role attributes for list items
        // https://github.com/Splidejs/splide/issues/825#issuecomment-2365324992
        splide.on("mounted", function () {
            let $slides = carousel.find(".splide__slide");
            let $slideList = carousel.find(".splide__list");

            $slides
                .removeAttr("role")
                .attr("role", "listitem");

            if ($slideList.length) {
                $slideList
                    .removeAttr("role")
                    .attr("role", "list");
            }
        });

        splide.on("mounted resize", function () {
            const totalSlides = carousel.find(".splide__slide").length;
            const perPage = splide.options.perPage;
            const arrows = carousel.find(".splide__arrow");
            const shouldHideControls = totalSlides <= perPage;

            arrows.css("display", shouldHideControls ? "none" : "");

            if (shouldHideControls) {
                splide.options.padding = {
                    left: "0.75rem",
                    right: "0.75rem"
                };

                splide.refresh();
            }
        });

        splide.mount();
    }

    return {
        Init: Init
    };
})(jQuery);